import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Pagina from '../../components/Pagina';
import FichaCadastroGenerico, { Campo } from '../../components/FichaCadastroGenerico';

import { buscarCamposLayout } from '../../services/layout';
import { getConfigRelatorio } from '../../constants/relatorios';

export default function ConsultarRelatorio() {
  const { entidade } = useParams();
  const configRelatorio = getConfigRelatorio(entidade);
  const [campos, setCampos] = useState<Campo[]>([]);
  const [dados, setDados] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!configRelatorio) return;

    let cancelado = false;

    async function getCamposRelatorio(tabela: string) {
      try {
        const novosCampos = await buscarCamposLayout(tabela);

        if (cancelado) return;

        const novosDados = novosCampos
          .filter(campo => campo.tipinp !== 'button')
          .reduce<Record<string, string>>((acc, campo) => ({ ...acc, [campo.campo]: '' }), {});

        setDados(novosDados);
        setCampos(novosCampos);
      } catch (error) {
        console.log(error);
        toast.error(`Erro ao carregar campos. ${entidade}`);
      }
    }

    setCampos([]);
    setDados({});
    getCamposRelatorio(configRelatorio.tabela);

    return () => {
      cancelado = true;
    };
  }, [configRelatorio?.tabela]);

  if (!entidade || !configRelatorio) {
    return <Pagina titulo='Relatório não encontrado' />;
  }

  return (
    <Pagina
      titulo={configRelatorio.titulo ?? `Relatório ${entidade.slice(0, 1).toLocaleUpperCase() + entidade.slice(1)}`}
      subtitulo='Informe os filtros e clique em Consultar'
    >
      <FichaCadastroGenerico
        key={configRelatorio.tabela}
        entidade={entidade}
        campos={campos}
        // @ts-ignore
        dados={dados}
      />
    </Pagina>
  );
}
